import { Link } from "react-router-dom";

export const LogoMark = ({ size = 30 }) => (
  <img
    src="/brand-logo.png"
    width={size}
    height={size}
    alt="ForexBrokerSignals"
    className="object-contain select-none transition-transform duration-300 group-hover:scale-105"
    style={{ width: size, height: size }}
    draggable={false}
  />
);

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
    <LogoMark />
    <span className={`text-[16px] font-medium tracking-[-0.025em] ${dark ? "text-white" : "text-[var(--ink)]"}`}>
      ForexBroker<span className="text-[var(--cobalt)]">Signals</span>
    </span>
  </Link>
);
